<template>
  <div class="row">
    <div class="row">
      <div class="col-md-12">
        <a href="/dashboard/map" class="btn btn-cyan"><i class="fa fa-arrow-circle-left"></i></a>
      </div>
    </div>
    <div class="row" v-if="loader">
      <div class="col-md-12 loader-spinner-graph">
        <div class="loadingio-spinner-wedges-r4aozssjb1">
          <div class="ldio-brup1v2qwjn">
            <div>
              <div><div></div></div>
              <div><div></div></div>
              <div><div></div></div>
              <div><div></div></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <h4 class="text-center"  style="font-size: 28px;">Cascade of services accessed by PWID  ({{ activeCity }}) - Kpk</h4>
    </div>
    <div class="col-md-6">
      <div id="container" class="mt-5"></div>
      <div class="margin-top-minus-150">
        <div id="testedReactivePieChart"></div>
      </div>
    </div>
    <div class="col-md-6 mt-5">
      <svg
        id="map2"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="800 0 728 800"
        style="display: block"
      >
        <g
          class="model-green filter-shaddow"
          id="Khyber Pakhtunkhwa"
          fill="#ffffd0"
          stroke="#d0c0a0"
          transform="translate(-27.1,-28.1)"
        >
          <a
            id="state_Upper_Dir"
            class="state"
            data-toggle="tooltip"
            data-html="true"
            title="Dir"
            xlink:href="javascript:void(0);"
            v-on:click="triggerChart(41); return false;"
          >
            <path
              id="Upper_Dir"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['DIR']]"


              d="m 1093.4,260.2 1.8,8 31.2,-3.6 12.4,19.6 12.6,0.2 17.6,-40 6.2,-29 -14.6,-24 1,-4.2 -8,-2.8 -46.4,63.6 z"
            />
          </a>

          <a
            id="state_Tank"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Tank"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 951.2,614.5 -5,-21.4 30.2,-21 9.4,-14.4 10,6 2.6,-6.2 13,11.4 -3.8,17.2 -13.6,18.8 -36,13 z"
            />
          </a>

          <a
            id="state_Swat"
            class="state"
            xlink:href="javascript:void(0);"
            data-toggle="tooltip"
            data-html="true"
            title="Swat"
            v-on:click="triggerChart(40); return false;"
          >
            <path
              id="Swat"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['SWT']]"


              d="m 1169,244.4 -17.6,40 7.8,13 -7.4,9.6 2.6,10.2 7,0 27.8,-15.4 6.6,-33.4 12.8,-19.4 7,-19.8 -4.6,-6.4 11.4,-50.8 -15.4,4.4 -15.8,-9.4 -13.2,19.2 -16.4,1 -1,4.2 14.6,24 z"
            />
          </a>

          <a
            id="state_Swabi"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Swabi"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 1165.2,393.6 20.4,-9.4 32.4,-24.2 -7.8,-18 -17,17.6 -12,-3.6 8,-16.2 -7,-2.2 -10.2,14.6 -9.8,2.6 -1.8,16.8 z"
            />
          </a>

          <a
            id="state_Shangla"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Shangla"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 1217.8,269.4 -9.2,-20.4 -12.8,19.4 -6.6,33.4 7.6,7.2 11,-5.8 3.2,16.2 8,-6 -2.2,-9 3.6,-14.2 5.2,3.2 4.6,-15.6 -3.6,-9.4 z"
            />
          </a>

          <a
            id="state_Peshawar"
            class="state"
            xlink:href="javascript:void(0);"
            v-on:click="triggerChart(28); return false;"
            data-toggle="tooltip"
            data-html="true"
            title="Peshawar"
          >
            <path
              id="Peshawar"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['PEW']]"


              d="m 1089,406.1 0.2,9 9.4,3 10.6,-3.8 4.2,-7.2 3.4,-14.9 -5.4,-17.2 -25.6,-12.4 -9.8,13 5,25.9 z"
            />
          </a>

          <a
            id="state_Nowshera"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Nowshera"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 1165.2,393.6 -4.8,-22 -7.2,2.8 -20.8,-5.6 -6.4,12.8 -14.6,-6.6 5.4,17.2 -3.4,14.9 10.2,6.8 1.4,4.2 19.2,-3.6 21,-2.2 z"
            />
          </a>

          <a
            id="state_Mardan"
            class="state"
            xlink:href="javascript:void(0);"
            data-toggle="tooltip"
            data-html="true"
            title="Mardan"
            v-on:click="triggerChart(39)"
          >
            <path
              id="Mardan"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['MDN']]"


              d="m 1121.8,350.4 10.6,18.4 20.8,5.6 7.2,-2.8 1.8,-16.8 9.8,-2.6 10.2,-14.6 -18.8,-6 -2.4,-7.2 -21.2,1.8 -15.6,15.8 z"
            />
          </a>

            <a
                id="state_Mansehra"
                class="state"
                xlink:href="javascript:void(0);"
                data-toggle="tooltip"
                data-html="true"
                title="Mansehra"
                v-on:click="triggerChart(45)"
            >
                <path
                    id="Mansehra"
                    class="shape"
                    stroke="#FFF"
                    stroke-width="1"
                    :class="[citiesColors['MSR']]"
                    d="m 1225.6,293.4 -5.2,-3.2 -3.6,14.2 2.2,9 -8,6 -3,7 5,9.2 12.4,4.6 11,10 20.2,-3.4 15.8,-16 11,-2 3,-9 16.6,1 9,-23.4 25.4,-11 11.4,-18.6 -2.8,-4.2 6.6,-7.4 -21.2,-9.4 -16,14.2 -20.4,2.8 -10.2,11.6 -12,22.8 -14.2,-6 -12,18.4 -17.2,0.4 z"
                />
            </a>

          <a
            id="state_Malakand"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Malakand"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 1107.6,333.2 -5,-8.8 3.8,-10 8.6,-5 36.8,-2.4 2.6,10.2 7,0 -0.4,7.2 -21.2,1.8 -15.6,15.8 z"
            />
          </a>

          <a
            id="state_Lower_Dir"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Lower_Dir"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 1151.4,284.4 -12.6,-0.2 -12.4,-19.6 -31.2,3.6 -5.4,6.4 10,17 15.6,4.2 -0.4,13.6 36.8,-2.4 7.4,-9.6 z"
            />
          </a>

          <a
            id="state_Lakki_Marwat"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Lakki_Marwat"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 986.4,544.3 12,13.2 13,11.4 -3.8,17.2 56.8,-28.2 0.2,-10.6 -7.6,0 -6.4,-19 -15.8,-10.8 -18.4,10.8 -17.8,-5.2 -19.6,13.2 z"
            />
          </a>

          <a
            id="state_Kohistan"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Kohistan"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 1215.6,229.2 -7,19.8 9.2,20.4 8.8,-1 3.6,9.4 12,-7 42.6,4.6 10.2,-11.6 20.4,-2.8 16,-14.2 -18.6,-1.6 -3,-11.2 1.4,-11.4 9.4,-10 -53,-13 -16,-14 0.6,-11.6 -4.8,-3 -9.8,3.6 -15.2,-2.6 -11.4,50.8 z"
            />
          </a>

          <a
            id="state_Kohat"
            class="state"
            xlink:href="javascript:void(0);"
            data-toggle="tooltip"
            data-html="true"
            title="Kohat"
            v-on:click="triggerChart(43); return false;"
          >
            <path
              id="Kohat"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['KHT']]"


              d="m 1050.2,418.1 -2.4,15.8 16.6,2.6 -14,23.4 27.8,13.4 18.4,2.2 4.8,12.6 10.8,4.6 4.2,-12.8 -5.6,-10.4 2.4,-9.4 14,-6.4 9.2,-14 7.8,-25.2 -19.2,3.6 -5,5 2,6 -13.8,11.2 -8,0.8 -3,-5.4 4.2,-4.8 -18.4,-3.6 -10.2,1.8 -16.6,-11.6 z"
            />
          </a>

          <a
            id="state_Karak"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Karak"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 1029,464.1 -16.6,9.4 13.2,5.2 -15.8,16.4 20.6,5.8 4.4,16.6 15.8,10.8 3.6,-19.6 12.8,-8 15.2,-1.6 2.2,-7.4 -6.2,-18.4 -27.8,-13.4 z"
            />
          </a>

          <a
            id="state_Haripur"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Haripur"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 1185.6,384.2 17.2,9.4 -2.6,5.4 7.2,2.5 7,-7.3 8.6,5.8 2.6,8.9 -5.2,4.8 10.8,4.2 25.6,-9.2 3,-19.5 -8.8,-3.8 4.6,-14.4 -9.4,0 1,-6.6 -10.8,-14.2 -11,-10 -12.4,-4.6 -2.8,6.4 7.8,18 z"
            />
          </a>

          <a
            id="state_Hangu"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Hangu"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 1029,464.1 -16.6,9.4 -10.8,-4.2 -4.8,-5.8 -9.2,-11.2 23.4,-8.2 3.2,-10 17,2.8 16.6,-3 16.6,2.6 -14,23.4 z"
            />
          </a>

          <a
            id="state_Dera_Ismail_Khan"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Dera_Ismail_Khan"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 1016.4,699.3 7.6,-14.4 4.4,-14.8 -6,-1 4.4,-16.6 15.8,-23.2 9.8,-30.6 11,-21.8 10,-3.8 0.6,-18.8 -9.6,3.6 -56.8,28.2 -13.6,18.8 -36,13 2.6,27.2 18.4,60.4 16.6,-13.8 13.6,1.6 z"
            />
          </a>

          <a
            id="state_Chitral"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Chitral"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 1130.6,97.4 2.8,-6.4 16,-4.2 0.6,-5.8 11.2,-2 -1.8,-3.2 4.6,-7 25.4,-2.8 14.2,-8.2 28.6,0.4 4.4,-3.2 5.8,1.6 11.8,-4 21.2,1.6 28.6,-2.6 8.4,8.2 12.8,5.4 -0.6,9 -26.2,0 -21.4,-4.8 -32.4,8.6 2.6,7.8 -11.6,15.6 -7.4,1.4 -2.8,8.6 -30.8,18.4 -2.6,17.4 4.4,7.4 -5.2,12.4 -13.2,19.2 -16.4,1 -8,-2.8 -46.4,63.6 -12,-11.6 9.4,-18 -5.4,-5.2 1.8,-8.6 -11.2,-6.2 4.6,-10.8 -6.6,-4.8 -1.2,-8.4 -9.2,-13.6 -17.4,-9.4 4.4,-10 31.4,-23.4 0.2,-5.8 8.6,-12.2 19.6,11.4 1.8,-5.2 -4.4,-1.6 1.4,-7.2 z"
            />
          </a>
          <a
            id="state_Charsadda"
            class="state"
            xlink:href="javascript:void(0);"
            v-on:click="triggerChart(38); return false;"
            data-toggle="tooltip"
            data-html="true"
            title="Charsadda"
          >
            <path
              id="Charsadda"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['CHD']]"


              d="m 1107.6,333.2 16.6,8.8 -2.4,8.4 10.6,18.4 -6.4,12.8 -14.6,-6.6 -25.6,-12.4 z"
            />
          </a>

          <a
            id="state_Buner"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Buner"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 1196.8,309 11,-5.8 3.2,16.2 -3,7 5,9.2 -2.8,6.4 -17,17.6 -12,-3.6 8,-16.2 -7,-2.2 -18.8,-6 -2.4,-7.2 0.4,-7.2 27.8,-15.4 z"
            />
          </a>

          <a
            id="state_Battagram"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Battagram"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 1242.2,270.8 42.6,4.6 -12,22.8 -14.2,-6 -12,18.4 -17.2,0.4 -3.8,-17.6 4.6,-15.6 z"
            />
          </a>

          <a
            id="state_Bannu"
            class="state"
            xlink:href="javascript:void(0);"
            data-toggle="tooltip"
            data-html="true"
            title="Bannu"
            v-on:click="triggerChart(42); return false;"
          >
            <path
              id="Bannu"
              class="shape"
              stroke="#FFF"
              stroke-width="1"


              :class="[citiesColors['BNU']]"
              d="m 976.4,521.3 2.6,15 19.6,-13.2 17.8,5.2 18.4,-10.8 -4.4,-16.6 -20.6,-5.8 -17.2,-0.8 z"
            />
          </a>

          <a
            id="state_Abbotabad"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Abbotabad"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 1291.2,384.2 -11.4,-44.6 3.6,-10.8 -11,2 -15.8,16 -20.2,3.4 10.8,14.2 -1,6.6 9.4,0 -4.6,14.4 8.8,3.8 -3,19.5 16.6,-9.2 4.6,-9.3 z"
            />
          </a>

          <path
            id="Khyber_Pakhtunkhwah_Border"
            fill="none"
            stroke="#a08070"
            d="m 1244.6,78 32.4,-8.6 21.4,4.8 26.2,0 0.6,-9 -12.8,-5.4 -8.4,-8.2 -28.6,2.6 -21.2,-1.6 -11.8,4 -5.8,-1.6 -4.4,3.2 -28.6,-0.4 -14.2,8.2 -25.4,2.8 -4.6,7 1.8,3.2 -11.2,2 -0.6,5.8 -16,4.2 -2.8,6.4 -7.6,0 -1.4,7.2 4.4,1.6 -1.8,5.2 -19.6,-11.4 -8.6,12.2 -0.2,5.8 -31.4,23.4 -4.4,10 17.4,9.4 9.2,13.6 1.2,8.4 6.6,4.8 -4.6,10.8 11.2,6.2 -1.8,8.6 5.4,5.2 -9.4,18 12,11.6 -13.8,12.2 1.8,8 -5.4,6.4 10,17 15.6,4.2 -0.4,13.6 -8.6,5 -3.8,10 5,8.8 -21.8,29.4 -9.8,13 5,25.9 8,4.6 0.2,9 9.4,3 10.6,-3.8 4.2,-7.2 10.2,6.8 1.4,4.2 -5,5 2,6 -13.8,11.2 -8,0.8 -3,-5.4 4.2,-4.8 -18.4,-3.6 -10.2,1.8 -16.6,-11.6 -6,0.6 -2.4,15.8 -16.6,3 -17,-2.8 -3.2,10 -23.4,8.2 14,17 10.8,4.2 13.2,5.2 -15.8,16.4 -17.2,-0.8 -16.2,27 2.6,15 7.4,8 12,13.2 -2.6,6.2 -10,-6 -9.4,14.4 -30.2,21 5,21.4 6.8,3.4 2.6,27.2 18.4,60.4 16.6,-13.8 13.6,1.6 7.2,6 7.6,-14.4 4.4,-14.8 -6,-1 4.4,-16.6 15.8,-23.2 9.8,-30.6 11,-21.8 10,-3.8 0.6,-18.8 -9.6,3.6 0.2,-10.6 -7.6,0 -6.4,-19 3.6,-19.6 12.8,-8 15.2,-1.6 2.2,-7.4 -6.2,-18.4 18.4,2.2 4.8,12.6 10.8,4.6 4.2,-12.8 -5.6,-10.4 2.4,-9.4 14,-6.4 9.2,-14 7.8,-25.2 21,-2.2 0,-18.7 20.4,-9.4 17.2,9.4 -2.6,5.4 7.2,2.5 7,-7.3 8.6,5.8 2.6,8.9 -5.2,4.8 10.8,4.2 25.6,-9.2 16.6,-9.2 4.6,-9.3 13.2,-6 -11.4,-44.6 3.6,-10.8 3,-9 16.6,1 9,-23.4 25.4,-11 11.4,-18.6 -2.8,-4.2 6.6,-7.4 -21.2,-9.4 -18.6,-1.6 -3,-11.2 1.4,-11.4 9.4,-10 -53,-13 -16,-14 0.6,-11.6 -4.8,-3 -9.8,3.6 -15.2,-2.6 -15.4,4.4 -15.8,-9.4 5.2,-12.4 -4.4,-7.4 2.6,-17.4 30.8,-18.4 2.8,-8.6 7.4,-1.4 11.6,-15.6 z"
          />
        </g>

              <g
                    id="Labels"
                    font-size="10"
                    font-family="DejaVu Sans"
                    transform="translate(-25.1,-30.1)"
                >
                    <text y="515.84082" x="990.0647">BANNU</text>
                    <!-- <text y="491.84082" x="1034.6155">KARAK</text>
                    <text y="455.84082" x="1009.51">HANGU</text>
                    <text y="398.41504" x="895.38696">KURRAM •</text>
                    <text y="407.52051" x="966.45337">KHYBER •</text>
                    <text y="342.32422" x="1016.6467">MOHMAND •</text>
                    <text y="303.76074" x="1069.717">BAJUR</text>
                    <text y="430.32068" x="970.4812">ORAKZAI •</text>
                    <text y="420.81445" x="1041.8549">FR PESHWAR •</text>
                    <text y="434.81348" x="1107.3168">• FR KOHAT</text> -->
                    <text y="457.84082" x="1071.342">KOHAT</text>
                    <!-- <text y="403.0376" x="1130.675">• NOWSHERA</text>
                    <text y="372.11816" x="1164.9006">SWABI</text> -->
                    <text y="349.61816" x="1130.3323" onclick="olamba()">MARDAN</text>
                    <!-- <text y="327.46094" x="1065.0198">MALAKAND •</text>
                    <text y="298.37646" x="1131.0653">• LOWER DIR</text> -->
                    <text y="237.03711" x="1087.3147">UPPER DIR •</text>
                    <!-- <text y="148.11816" x="1120.1223">CHITRAL</text>
                    <text y="328.45117" x="1168.678">BUNER</text>
                    <text y="275.50208" x="1152.8286">SHANGLA •</text> -->
                    <text y="241.61816" x="1177.0706">SWAT</text>
                    <!-- <text y="385.11816" x="1200.0121">HARIPUR</text>-->
                    <text y="325.11816" x="1220.676">MANSEHRA</text>
                  <!--<text y="297.61816" x="1239.261">• BATTAGRAM</text>
                  <text y="237.61816" x="1238.9553">KOHISTAN</text> -->
                    <text y="393.01855" x="1036.6448">PESHAWAR •</text>
                    <text y="360.02246" x="1042.9407">CHARSADDA •</text>
                </g>

      </svg>
      <div class="positive-ratio-colors"  v-on:click="triggerChart(46)">
        <span
            type="button"
            class="text-bold"
            style="width:70px; font-size: 10px; margin-bottom: 1px; text-align: center;"
        >
          HIV positivity rate
        </span>
          <br />
          <button
          type="button"
          class="btn btn-default text-white text-bold  btn-ratio"
          style="background: rgb(245, 183, 177); width:70px; font-size: 10px;"
        >
          < 20%
        </button>
        <br />
        <button
          type="button"
          class="btn btn-default text-white text-bold  btn-ratio"
          style="background: rgb(255 141 129); width:70px; font-size: 10px;"
        >
          21-40%
        </button>
        <br />
        <button
          type="button"
          class="btn btn-default text-white text-bold  btn-ratio"
          style="background: rgb(228 94 80); width:70px; font-size: 10px;"
        >
          41-60%
        </button>
        <br />
        <button
          type="button"
          class="btn btn-default text-white text-bold btn-ratio"
          style="background: rgb(226, 23, 23); width:70px; font-size: 10px;"
        >
           60% +
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling
export default {
  data() {
    return {
      citiesColors: [],
      loader: true,
      chart: null,
      chartSpouse: null,
      isClient: true,
      tested: null,
      reactive: null,
      tableDataCities: null,
      citySpots: 0,
      activeCity : 'Overall',
    };
  },
  methods: {
    async callPositivePWID() {
      await axios
        .get("prevalenceHtc")
        .then((response) => {
          if (response.status == 200) {
            this.citiesColors = response.data;
            loader = false;
          }
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loader = false));
    },
    async callPWID() {
      var dataSeries = [];
      var column = {
        data: [],
      };
      await axios
        .get("byCitiesPWIDKpk")
        .then((response) => {
          response.data.forEach((data) => {
            column.name = data.CityShortName;
            if (column.name == "AllKpk") {
              column.visible = true;
              column.color = "#287161";
            } else {
              column.visible = false;
              column.color = "#287161";
            }
            column.data.push(parseInt(data.ActiveCases));
            column.data.push(parseInt(data.DistinctVCCT));
            column.data.push(parseInt(data.Reactive));
            column.data.push(parseInt(data.RegART));
            column.data.push(parseInt(data.OnART));
            column.data.push(parseInt(data.CompletedAAU));
            column.data.push(parseInt(data.Adherent));
            // column.data.push(parseInt(data.ViralLoadTested));
            // column.data.push(parseInt(data.ViralLoadSuppressed));


            dataSeries.push(column);
            column = {
              data: [],
            };
          });
        dataSeries.forEach(this.colorizeData);
          this.chart = Highcharts.chart("container", {
            chart: {
              type: "column",
              animation: false,
                style: {
                    fontFamily: 'Ubuntu',
                    fontWeight: '700'
                }
            },
            title: {
              text: "",
            },
            xAxis: {
              categories: [
                "Active<br>Cases",
                "Tested",
                "Reactive",
                "ART<br>Registered",
                "On<br>ART(ARV)",
                "Completed<br>AAU",
                "Adherent",
                // "ViralLoad<br>Tested",
                // "VL<br>Supressed",
              ],
              labels : {
                useHTML : true,
                style : {
                  fontSize: '8px',
                  wordBreak: 'break-all',
                    fontWeight: '700',
                    fontFamily: 'Ubuntu',
                }
              },
              crosshair: true,
            },
            yAxis: {
              stackLabels: {
                style: {
                    fontSize: '2px',
                },
                enabled: false,
              },
              min: 0,
              title: {
                text: "Number of PWID",
              },
            },
            tooltip: {
              headerFormat:
                '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat:
                '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y}</b></td></tr>',
              footerFormat: "</table>",
              shared: true,
              useHTML: true,
            },
            plotOptions: {
                column: {
                    pointPadding: 0.1,
                    borderWidth: 0,
                },
              color: {
                radialGradient: { cx: 0.5, cy: 0.5, r: 0.5 },
                stops: [
                    [0, "#003399"],
                    [1, "#3366AA"],
                ],
              },
              series: {
                pointPadding: 0,
                groupPadding: 0,
                point: {
                  events: {
                    click: function(){
                      // console.log(this.name)
                      // console.log(this.category)
                      // console.log(this.x)
                      // console.log(this.y)
                    }
                  }
                },
                dataLabels: {
                  enabled: true,
                    style: {
                        fontSize: '10px',
                        fontWeight: '700',
                        fontFamily: 'Ubuntu',
                    },
                    // format: '<b>{point.name}</b>:- ({y}) <br/> {point.percentage:.1f}%',
                    formatter: function() {
                        return Number(this.y).toLocaleString();
                        // return this.y + '<br>' + this.x
                    }
                }
              },
            },
            credits: {
              enabled: false,
            },
            legend: {
                enabled: false
            },
            series: dataSeries,
          });
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loader = false));
    },
    async callPWIDPositiveTested(){
      await axios
        .get("pwidReactiveTestedKpk")
        .then((response) => {
          if (response.status == 200) {
            this.tableDataCities = response.data;
            this.populatePieCharts('AllKpk');
          }
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loader = false));
    },
    populatePieCharts(city){
        console.log(city)
      var testedReactiveData = [{
        name : 'Reactive',
        y : parseInt(this.tableDataCities[city].Reactive)
      }, {
        name : 'Negative',
        y : parseInt(this.tableDataCities[city].DistinctVCCT) - parseInt(this.tableDataCities[city].Reactive)
      }];

      var genderData = [{
        name : 'Male',
        y : parseInt(this.tableDataCities[city].Male)
      }, {
        name : 'Female',
        y : parseInt(this.tableDataCities[city].Female)
      }];

      var ageData = [{
        name : 'Age > 25',
        y : parseInt(this.tableDataCities[city].Male25Greater)
      }, {
        name : 'Age < 25',
        y : parseInt(this.tableDataCities[city].Male25Less)
      }];

      this.populateTestedReactiveGender(testedReactiveData, genderData, ageData);
    },
    populateTestedReactiveGender(testedreactive, genders, ages){
      var chart = Highcharts.chart('testedReactivePieChart', {
          chart: {
              plotBackgroundColor: null,
              plotBorderWidth: null,
              plotShadow: false,
              type: 'pie'
          },
          title: {
              text: '',
              style : {
                'fontSize' : '12px'
              }
          },
          tooltip: {
              enabled : false,
              pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
          },
          accessibility: {
              point: {
                  valueSuffix: '%'
              }
          },
          plotOptions: {
              pie: {
                  size: 150,
                  allowPointSelect: false,
                  cursor: 'pointer',
                  colors: ['#198754', '#dc3545'],
                  dataLabels: {
                      distance: 10,
                      enabled: true,
                      style : {
                          fontSize: '10px',
                          fontWeight: '700',
                          fontFamily: 'Ubuntu',
                      },
                      format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                  }
              }
          },
          credits: {
              enabled: false,
          },
          series: [{
              name: 'PWIDs',
              center: [130, 100],
              colorByPoint: true,
              colors: ['#dc3545', '#198754'],
              data: testedreactive
          },
          {
              name: 'PWIDs',
              center: [400, 100],
              colorByPoint: true,
              colors: [ '#17a2b8', '#ffc107'],
              data: ages
          }],
      });
      return false;
    },
    triggerChart(x) {
      this.loader = true
      this.activeCity = this.chart.series[x].name;
      $(this.chart.series).each(function (i, e) {
        e.hide();
      });
      this.chart.series[x].show()
      this.loader = false
      this.populatePieCharts(this.chart.series[x].name);
    },
      colorizeData(data) {
          data.color = {
              radialGradient: {cx: 0.5, cy: 0.3, r: 0.7},
              stops: [
                  [0, data.color],
                  [1, Highcharts.Color(data.color).brighten(-0.3).get('rgb')] // darken
              ]
          };
      }
  },
  mounted() {
    this.callPositivePWID();
    this.callPWIDPositiveTested();
    this.callPWID();


  },
};
</script>

<style lang="scss" scoped>
.filter-shaddow {
    filter: drop-shadow(9px 4px 5px rgb(79 79 79 / 93%));
}
#populatePieCharts{
  height: 200px;
}
#container {
  height: 300px;
  // -webkit-box-shadow: -1px 4px 16px -5px rgba(0,0,0,0.93);
  // box-shadow: -1px 4px 16px -11px rgb(0 0 0 / 76%)
}
#containerSpouse {
  height: 500px;
}
.margin-top-minus-150{
  margin-top: -100;
}
.shadow {
  // -webkit-filter: drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.7));
  // filter: drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.7));
  // /* Similar syntax to box-shadow */
  -webkit-box-shadow: -1px 4px 16px -5px rgba(0, 0, 0, 0.93);
  box-shadow: -1px 4px 16px -5px rgba(0, 0, 0, 0.93);
}
#map2 {
  display: none;
}

#map2 .state {
  cursor: pointer;
}

#map2 .state .shape {
  cursor: pointer;
  -width: 0;
}

#map2 .state .label_icon_state {
  fill: #fff;
  font-family: Arial;
  font-size: 11px;
  line-height: 12px;
  font-weight: normal;
}

#map2 .state .label_state {
  display: none;
  font-family: Arial;
  font-size: 14px;
  line-height: 16px;
  font-weight: bold;
}

#map2 .state:hover .label_state,
#map2 .state.hover .label_state {
  display: block;
}

#map2 .model-green .state .shape {
  fill: #e6e6e6;
}

#map2 .model-green .state .icon_state {
  fill: #05110a;
}

#map2 .model-green .state .label_icon_state {
  fill: #fff;
}

#map2 .model-green .state .label_state {
  fill: #666;
}

#map2 .model-green .state:hover .shape,
#map2 .model-green .state.hover .shape {
  fill: #9c9c9c;
}

#map2 .model-green .state:hover .icon_state,
#map2 .model-green .state.hover .icon_state {
  fill: #9c9c9c;
}

#map2 .model-orange .state .shape {
  fill: #fd7132;
}

#map2 .model-orange .state .icon_state {
  fill: #6cb361;
}

#map2 .model-orange .state .label_icon_state {
  fill: #fff;
}

#map2 .model-orange .state .label_state {
  fill: #666;
}

#map2 .model-orange .state:hover .shape,
#map2 .model-orange .state.hover .shape {
  fill: #c93f04;
}

#map2 .model-orange .state:hover .icon_state,
#map2 .model-orange .state.hover .icon_state {
  fill: #10592f;
}

#map2 .model-darkgreen .state .shape {
  fill: #366823;
}

#map2 .model-darkgreen .state .icon_state {
  fill: #2779c6;
}

#map2 .model-darkgreen .state .label_icon_state {
  fill: #fff;
}

#map2 .model-darkgreen .state .label_state {
  fill: #666;
}

#map2 .model-darkgreen .state:hover .shape,
#map2 .model-darkgreen .state.hover .shape {
  fill: #4a8c31;
}

#map2 .model-darkgreen .state:hover .icon_state,
#map2 .model-darkgreen .state.hover .icon_state {
  fill: #5a95ce;
}
.class0-20 {
  fill: rgb(245, 183, 177) !important;
}
.class20-40 {
  fill: rgb(255 141 129) !important;
}
.class40-60 {
  fill: rgb(228 94 80) !important;
}
.class60-100 {
  fill: rgb(226, 23, 23) !important;
}
.class100 {
  fill: #afafaf !important;
}
.text {
 fill: #fff !important;
  font-size: 10px;
  text-shadow: 2px 3px 6px #000;
  font-weight: 700;
  letter-spacing: 1px;
}
.positive-ratio-colors {
  position: absolute;
  top: 60%;
  right: 80px;
}
text {
  fill: #fff !important;
  font-size: 10px;
  text-shadow: 2px 3px 6px #000;
  font-weight: 700;
  letter-spacing: 1px;
}
</style>
